import { lessonplanOverviewBullets } from "./TTHTLessonPlanOverviewSection.consts";
import { TTHTBullet } from "../../../../components/TTHTBullet";
import React from "react";
import {
  TTHTLessonPlanOverviewImageContainer,
  TTHTLessonPlanOverviewContentWrapper,
  TTHTLessonPlanOverviewTextContainer,
} from "./TTHTLessonPlanOverviewSection.styled";
import {
  TTHTSectionContent,
  TTHTSectionTitle,
  TTHTSection,
  TTHTSectionWrapper,
} from "../../../TeachersToolkitHowTo.styled";

export const TTHTLessonPlanOverviewSection = () => (
  <TTHTSection bgcolor="#EDEDED">
    <TTHTSectionWrapper>
      <TTHTSectionContent>
        <TTHTLessonPlanOverviewContentWrapper>
          <TTHTLessonPlanOverviewTextContainer>
            <TTHTSectionTitle size="sm">Lesson Plan Overview</TTHTSectionTitle>
            <br />
            {lessonplanOverviewBullets.map((bullet, index) => (
              <TTHTBullet
                key={index}
                number={index + 1}
                title={bullet.name}
                text={bullet.description}
              />
            ))}
          </TTHTLessonPlanOverviewTextContainer>
          <TTHTLessonPlanOverviewImageContainer>
            <img
              className="img-fluid "
              src="/img/ttht/lessonplan-overview.jpg"
            />
          </TTHTLessonPlanOverviewImageContainer>
        </TTHTLessonPlanOverviewContentWrapper>
      </TTHTSectionContent>
    </TTHTSectionWrapper>
  </TTHTSection>
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/LessonPlanOverview/TTHTLessonPlanOverviewSection.js